import PositionTypeMissing from './PositionTypeMissing';

export default PositionTypeMissing;



// WEBPACK FOOTER //
// ./src/client/Components/PositionTypeMissing/index.js